package org.hs_soft.runmynesto.pages.login.mvi

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.login.LoginStateEnum


data class LoginState(
    val userName:String ="",
    val password:String ="",
    val errorMsg:String="",
    val loginState:LoginStateEnum=LoginStateEnum.SIGN_IN,
    val isHoveredOnButton:Boolean=false,
    val isLoading:Boolean=false,
    val isCheckingLoggedInLoading:Boolean=false,
    val isLoggedIn:Boolean=false,
    val mfaCode:String="",
    val windowSizeMode: WindowSizeModeEnum = WindowSizeModeEnum.Desktop,
)